export const format = {
    mapAddressFields: fieldName => {
        switch (fieldName) {
            case 'neighborhood':
            case 'locality':
                return 'city'

            case 'administrative_area_level_1':
                return 'state'

            case 'postal_code':
            case 'postal_code_prefix':
                return 'zip'

            case 'route':
                return 'street'

            case 'administrative_area_level_2':
                return 'county'

            default:
                return fieldName
        }
    },
}
